// extracted by mini-css-extract-plugin
export default {"eyebrow":"Eyebrow_eyebrow__1F6vy","large":"Eyebrow_large__7c-9z"};